(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-femme-sansquizz"] && !Shopify.designMode) return;
  try {
    
(function(){
  const roots=document.querySelectorAll('.szhf-reco-only-root');
  const root=[...roots].find(function(el){
    return !el.dataset.szhfInitialized;
  });
  if(!root) return;
  root.dataset.szhfInitialized='true';

  const SPORT_ID=65264558899549;
  const COMFORT_ID=65264558932317;

  let currentModel='comfort';
  let variantId=COMFORT_ID;
  let galleryIndex=0;
  let miniTimer=null;
  let reviewVisible=6;
  let heroVisible=true;
  let finalVisible=false;

  /*
     La recommandation n'existe que si le quiz a réellement été complété
     pendant cette visite. On ne réutilise pas un ancien état localStorage
     au chargement, afin de toujours afficher d'abord « Trouver ma selle ».
  */
  let quizCompleted=false;
  let recommendedModel=null;

  const state={
    bike:'',
    bikeDefault:null,
    posture:'',
    pains:[],
    model:'comfort'
  };

  const REVIEWS = {
  "sport": [
    {
      "name": "Julie M.",
      "rating": 5,
      "bike": "VTT",
      "text": "Je roule surtout en VTT et j'avais toujours tendance à me décaler sur la selle après vingt minutes. Avec la Sport+, je reste beaucoup plus stable et j'y pense nettement moins pendant la sortie.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s6.png?v=1786347341",
      "reply": "Merci Julie 💙 Nous sommes ravis que votre vtt soit devenu plus agréable au quotidien. Bonne route !",
      "helpfulYes": 18,
      "helpfulNo": 1,
      "model": "sport"
    },
    {
      "name": "Camille R.",
      "rating": 5,
      "bike": "Gravel",
      "text": "Premier essai sur 32 km de gravel : très bonne surprise. La zone centrale me gêne moins et je n'ai pas eu cette sensation d'engourdissement que j'avais avec mon ancienne selle.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s8.png?v=1786347340",
      "reply": "Merci beaucoup Camille pour ce retour détaillé 💙 Heureux que la selle vous accompagne mieux sur votre gravel.",
      "helpfulYes": 14,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Sarah L.",
      "rating": 5,
      "bike": "Trekking",
      "text": "Je cherchais quelque chose de confortable sans avoir une selle énorme. La Sport+ garde une forme assez dynamique et convient vraiment bien à mon trekking.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s14.png?v=1786347335",
      "reply": "Merci Sarah 💙 Le bon réglage fait souvent une vraie différence. Très belles sorties avec votre trekking !",
      "helpfulYes": 22,
      "helpfulNo": 1,
      "model": "sport"
    },
    {
      "name": "Élodie B.",
      "rating": 5,
      "bike": "Route",
      "text": "J'ai mis deux sorties à trouver le bon réglage d'inclinaison. Une fois fait, la différence est claire sur mes sorties route, surtout au niveau des appuis.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s3.png?v=1786347326",
      "reply": "Merci pour votre retour Élodie 💙 Nous sommes heureux que vous ayez trouvé une position plus confortable.",
      "helpfulYes": 11,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Marine T.",
      "rating": 5,
      "bike": "VTT électrique",
      "text": "Je suis assez sensible aux frottements et c'était ma principale hésitation. Après plusieurs sorties, je trouve la position beaucoup plus naturelle et je bouge moins sur la selle.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s11.png?v=1786347325",
      "reply": "Un grand merci Marine 💙 Profitez bien de vos prochaines sorties en vtt électrique !",
      "helpfulYes": 27,
      "helpfulNo": 2,
      "model": "sport"
    },
    {
      "name": "Claire D.",
      "rating": 5,
      "bike": "VTT",
      "text": "Bonne selle, ferme juste ce qu'il faut. Elle ne donne pas la sensation de s'enfoncer et j'ai moins mal aux fesses après une heure de VTT.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s13.png?v=1786347342",
      "reply": "Merci Claire pour votre confiance 💙 Ravies de lire que vos appuis vous semblent plus naturels.",
      "helpfulYes": 9,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Anaïs P.",
      "rating": 5,
      "bike": "Gravel",
      "text": "Je l'ai prise pour mon gravel et elle correspond très bien à ma position légèrement penchée. Le canal central est vraiment appréciable sur les longues portions assises.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s15.png?v=1786347338",
      "reply": "Merci Anaïs 💙 C'est exactement le type de retour qui nous aide à continuer d'améliorer SelloZen.",
      "helpfulYes": 16,
      "helpfulNo": 1,
      "model": "sport"
    },
    {
      "name": "Sophie G.",
      "rating": 5,
      "bike": "Trekking",
      "text": "Je fais du vélotaf en trekking 4 jours par semaine. La Sport+ m'a surtout aidée sur les engourdissements, c'est ce que je remarque le plus.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s5.png?v=1786347339",
      "reply": "Merci beaucoup Sophie 💙 Nous vous souhaitons encore de nombreuses sorties confortables !",
      "helpfulYes": 13,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Lucie V.",
      "rating": 4,
      "bike": "Route",
      "text": "Sur route je voulais garder une selle qui ne bloque pas les mouvements. Elle est confortable sans être trop large, exactement ce que je cherchais.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s21.png?v=1786347337",
      "reply": "Merci Lucie 💙 Nous sommes ravis que votre route soit devenu plus agréable au quotidien. Bonne route !",
      "helpfulYes": 7,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Manon C.",
      "rating": 5,
      "bike": "VTT électrique",
      "text": "Installée sur mon VTT électrique depuis trois semaines. J'avais souvent une gêne au bassin après 40 minutes, beaucoup moins maintenant.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s20.png?v=1786347335",
      "reply": "Merci beaucoup Manon pour ce retour détaillé 💙 Heureux que la selle vous accompagne mieux sur votre vtt électrique.",
      "helpfulYes": 19,
      "helpfulNo": 1,
      "model": "sport"
    },
    {
      "name": "Laura F.",
      "rating": 5,
      "bike": "Gravel",
      "text": "Très simple à installer. Sur mon gravel, mes appuis sont mieux placés et je me redresse moins souvent pour soulager la pression.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s10.png?v=1786347334",
      "reply": "Merci Laura 💙 Le bon réglage fait souvent une vraie différence. Très belles sorties avec votre gravel !",
      "helpfulYes": 24,
      "helpfulNo": 1,
      "model": "sport"
    },
    {
      "name": "Émilie N.",
      "rating": 5,
      "bike": "VTT",
      "text": "Je ne pensais pas qu'une selle pouvait changer autant mon ressenti sur les petits chemins. Moins de points de pression et surtout moins besoin de changer de position.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s17.png?v=1786347329",
      "reply": "Merci pour votre retour Émilie 💙 Nous sommes heureux que vous ayez trouvé une position plus confortable.",
      "helpfulYes": 12,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Chloé A.",
      "rating": 5,
      "bike": "Trekking",
      "text": "Je fais beaucoup de trekking le week-end. La forme me convient mieux que les selles très larges que j'avais testées auparavant.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s9.png?v=1786347329",
      "reply": "Un grand merci Chloé 💙 Profitez bien de vos prochaines sorties en trekking !",
      "helpfulYes": 8,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Nina H.",
      "rating": 5,
      "bike": "Route",
      "text": "Je l'utilise sur un vélo route loisir, pas en compétition. Elle reste assez fine tout en étant bien plus agréable que ma selle d'origine.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s19.png?v=1786347328",
      "reply": "Merci Nina pour votre confiance 💙 Ravies de lire que vos appuis vous semblent plus naturels.",
      "helpfulYes": 17,
      "helpfulNo": 1,
      "model": "sport"
    },
    {
      "name": "Pauline S.",
      "rating": 5,
      "bike": "VTT",
      "text": "Très bonne pour ma position sur le VTT. J'ai dû baisser légèrement le nez de la selle et depuis c'est nickel.",
      "image": null,
      "reply": "Merci Pauline 💙 C'est exactement le type de retour qui nous aide à continuer d'améliorer SelloZen.",
      "helpfulYes": 10,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Marion E.",
      "rating": 5,
      "bike": "Gravel",
      "text": "Après 60 km de gravel, aucune irritation comme d'habitude. C'est la première chose que j'ai remarquée.",
      "image": null,
      "reply": "Merci beaucoup Marion 💙 Nous vous souhaitons encore de nombreuses sorties confortables !",
      "helpfulYes": 21,
      "helpfulNo": 1,
      "model": "sport"
    },
    {
      "name": "Mélanie J.",
      "rating": 5,
      "bike": "VTT électrique",
      "text": "Sur mon VTT électrique, je voulais plus de confort sans perdre une position dynamique. Le compromis est réussi.",
      "image": null,
      "reply": "Merci Mélanie 💙 Nous sommes ravis que votre vtt électrique soit devenu plus agréable au quotidien. Bonne route !",
      "helpfulYes": 6,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Amandine K.",
      "rating": 5,
      "bike": "Trekking",
      "text": "Je roule en trekking avec le buste légèrement incliné. La Sport+ me correspond mieux que les selles très rembourrées qui me gênaient entre les cuisses.",
      "image": null,
      "reply": "Merci beaucoup Amandine pour ce retour détaillé 💙 Heureux que la selle vous accompagne mieux sur votre trekking.",
      "helpfulYes": 15,
      "helpfulNo": 1,
      "model": "sport"
    },
    {
      "name": "Céline O.",
      "rating": 5,
      "bike": "Route",
      "text": "J'avais des engourdissements sur les sorties route de plus d'une heure. Ils ont nettement diminué après quelques réglages de hauteur.",
      "image": null,
      "reply": "Merci Céline 💙 Le bon réglage fait souvent une vraie différence. Très belles sorties avec votre route !",
      "helpfulYes": 23,
      "helpfulNo": 1,
      "model": "sport"
    },
    {
      "name": "Léa M.",
      "rating": 4,
      "bike": "Gravel",
      "text": "Très satisfaite. La selle paraît assez ferme au début mais les appuis sont mieux répartis et c'est plus agréable sur la durée.",
      "image": null,
      "reply": "Merci pour votre retour Léa 💙 Nous sommes heureux que vous ayez trouvé une position plus confortable.",
      "helpfulYes": 5,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Mathilde P.",
      "rating": 5,
      "bike": "VTT",
      "text": "Je fais surtout des sentiers VTT. Elle reste confortable même quand je change souvent de position et je n'ai plus cette pression centrale constante.",
      "image": null,
      "reply": "Un grand merci Mathilde 💙 Profitez bien de vos prochaines sorties en vtt !",
      "helpfulYes": 20,
      "helpfulNo": 1,
      "model": "sport"
    },
    {
      "name": "Aurélie R.",
      "rating": 5,
      "bike": "Trekking",
      "text": "Bon maintien sur mon trekking. Je trouve aussi que mon bassin bouge moins, ce qui rend les sorties plus fluides.",
      "image": null,
      "reply": "Merci Aurélie pour votre confiance 💙 Ravies de lire que vos appuis vous semblent plus naturels.",
      "helpfulYes": 9,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Caroline B.",
      "rating": 5,
      "bike": "VTT électrique",
      "text": "Je l'ai montée sur un VTTAE. Après quatre sorties, je la garde sans hésiter. Beaucoup moins de gêne sur la zone intime.",
      "image": null,
      "reply": "Merci Caroline 💙 C'est exactement le type de retour qui nous aide à continuer d'améliorer SelloZen.",
      "helpfulYes": 12,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Justine D.",
      "rating": 5,
      "bike": "Route",
      "text": "Je roule en route tranquille et je voulais quelque chose de moins agressif que ma selle d'origine. C'est réussi sans devenir trop large.",
      "image": null,
      "reply": "Merci beaucoup Justine 💙 Nous vous souhaitons encore de nombreuses sorties confortables !",
      "helpfulYes": 18,
      "helpfulNo": 1,
      "model": "sport"
    },
    {
      "name": "Noémie G.",
      "rating": 5,
      "bike": "Gravel",
      "text": "Le vrai plus pour moi est l'ouverture centrale. Sur gravel, je ressens moins la compression quand la sortie se prolonge.",
      "image": null,
      "reply": "Merci Noémie 💙 Nous sommes ravis que votre gravel soit devenu plus agréable au quotidien. Bonne route !",
      "helpfulYes": 14,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Alice V.",
      "rating": 5,
      "bike": "VTT",
      "text": "Confortable dès la deuxième sortie. La première j'avais placé la selle trop haute, après correction c'était beaucoup mieux.",
      "image": null,
      "reply": "Merci beaucoup Alice pour ce retour détaillé 💙 Heureux que la selle vous accompagne mieux sur votre vtt.",
      "helpfulYes": 11,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Charlotte L.",
      "rating": 5,
      "bike": "Trekking",
      "text": "Je fais des trajets mixtes route et chemins. Elle soutient bien sans me coincer dans une seule position.",
      "image": null,
      "reply": "Merci Charlotte 💙 Le bon réglage fait souvent une vraie différence. Très belles sorties avec votre trekking !",
      "helpfulYes": 25,
      "helpfulNo": 1,
      "model": "sport"
    },
    {
      "name": "Morgane T.",
      "rating": 5,
      "bike": "Route",
      "text": "Sur route, je sens surtout une meilleure répartition du poids. Je finis mes sorties avec moins de douleur au niveau des appuis.",
      "image": null,
      "reply": "Merci pour votre retour Morgane 💙 Nous sommes heureux que vous ayez trouvé une position plus confortable.",
      "helpfulYes": 7,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Éva C.",
      "rating": 5,
      "bike": "VTT électrique",
      "text": "Très bonne surprise sur VTT électrique. J'avais peur qu'elle soit trop sportive mais elle reste vraiment confortable.",
      "image": null,
      "reply": "Un grand merci Éva 💙 Profitez bien de vos prochaines sorties en vtt électrique !",
      "helpfulYes": 16,
      "helpfulNo": 1,
      "model": "sport"
    },
    {
      "name": "Margaux F.",
      "rating": 5,
      "bike": "Gravel",
      "text": "Je l'utilise en gravel depuis un mois. Moins de frottements et moins de besoin de me lever de la selle, donc validée pour moi.",
      "image": null,
      "reply": "Merci Margaux pour votre confiance 💙 Ravies de lire que vos appuis vous semblent plus naturels.",
      "helpfulYes": 10,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Hélène N.",
      "rating": 5,
      "bike": "VTT",
      "text": "La forme convient bien à mon VTT et à ma position légèrement inclinée. J'aurais juste aimé la tester plus tôt.",
      "image": null,
      "reply": "Merci Hélène 💙 C'est exactement le type de retour qui nous aide à continuer d'améliorer SelloZen.",
      "helpfulYes": 13,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Clara A.",
      "rating": 4,
      "bike": "Route",
      "text": "Je roule sur route deux à trois fois par semaine. La sensation de pression a diminué et je tiens plus longtemps sans y penser.",
      "image": null,
      "reply": "Merci beaucoup Clara 💙 Nous vous souhaitons encore de nombreuses sorties confortables !",
      "helpfulYes": 8,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Océane S.",
      "rating": 5,
      "bike": "Trekking",
      "text": "Bonne selle de trekking. Elle reste discrète visuellement et surtout je n'ai plus les engourdissements que j'avais au bout de 30 minutes.",
      "image": null,
      "reply": "Merci Océane 💙 Nous sommes ravis que votre trekking soit devenu plus agréable au quotidien. Bonne route !",
      "helpfulYes": 17,
      "helpfulNo": 1,
      "model": "sport"
    },
    {
      "name": "Fanny E.",
      "rating": 5,
      "bike": "Gravel",
      "text": "Très adaptée à mon gravel. Le confort vient surtout du fait que je me sens mieux soutenue et pas simplement d'un rembourrage mou.",
      "image": null,
      "reply": "Merci beaucoup Fanny pour ce retour détaillé 💙 Heureux que la selle vous accompagne mieux sur votre gravel.",
      "helpfulYes": 6,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Lise J.",
      "rating": 5,
      "bike": "VTT électrique",
      "text": "Montée sur mon vélo électrique sportif, elle a changé mes trajets de 45 minutes. Je ressens beaucoup moins les points de pression.",
      "image": null,
      "reply": "Merci Lise 💙 Le bon réglage fait souvent une vraie différence. Très belles sorties avec votre vtt électrique !",
      "helpfulYes": 15,
      "helpfulNo": 1,
      "model": "sport"
    },
    {
      "name": "Inès K.",
      "rating": 5,
      "bike": "VTT",
      "text": "Après plusieurs selles testées en VTT, c'est celle avec laquelle je bouge le moins pour chercher une position confortable.",
      "image": null,
      "reply": "Merci pour votre retour Inès 💙 Nous sommes heureux que vous ayez trouvé une position plus confortable.",
      "helpfulYes": 9,
      "helpfulNo": 0,
      "model": "sport"
    },
    {
      "name": "Maëlle O.",
      "rating": 5,
      "bike": "Route",
      "text": "Je voulais une selle route loisir plus tolérante. La Sport+ fait très bien le travail, surtout une fois l'inclinaison bien réglée.",
      "image": null,
      "reply": "Un grand merci Maëlle 💙 Profitez bien de vos prochaines sorties en route !",
      "helpfulYes": 12,
      "helpfulNo": 0,
      "model": "sport"
    }
  ],
  "comfort": [
    {
      "name": "Nathalie M.",
      "rating": 5,
      "bike": "Vélo électrique urbain",
      "text": "Je roule très droite sur mon vélo électrique et la Confort+ me convient vraiment mieux que ma selle d'origine. Je sens surtout moins de pression et je peux rester assise plus longtemps.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c26.png?v=1786345923",
      "reply": "Merci Nathalie 💙 Nous sommes ravis que votre vélo électrique urbain soit devenu plus agréable au quotidien. Bonne route !",
      "helpfulYes": 18,
      "helpfulNo": 1,
      "model": "comfort"
    },
    {
      "name": "Isabelle R.",
      "rating": 5,
      "bike": "Ville",
      "text": "Je fais mes trajets en ville tous les jours. Avant, j'avais mal aux fesses au bout de vingt minutes. La différence est nette avec celle-ci.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c20.png?v=1786345921",
      "reply": "Merci beaucoup Isabelle pour ce retour détaillé 💙 Heureux que la selle vous accompagne mieux sur votre ville.",
      "helpfulYes": 14,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Sandrine L.",
      "rating": 5,
      "bike": "Cargo",
      "text": "Installée sur mon vélo cargo pour les trajets avec les enfants. La largeur apporte un bon soutien sans donner l'impression d'être sur un coussin énorme.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c31.png?v=1786345918",
      "reply": "Merci Sandrine 💙 Le bon réglage fait souvent une vraie différence. Très belles sorties avec votre cargo !",
      "helpfulYes": 22,
      "helpfulNo": 1,
      "model": "comfort"
    },
    {
      "name": "Catherine B.",
      "rating": 5,
      "bike": "Vélo électrique urbain",
      "text": "Je cherchais surtout à enlever la gêne sur la zone intime. Après quelques sorties et un petit réglage d'inclinaison, c'est beaucoup plus agréable.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c28.png?v=1786345917",
      "reply": "Merci pour votre retour Catherine 💙 Nous sommes heureux que vous ayez trouvé une position plus confortable.",
      "helpfulYes": 11,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Valérie T.",
      "rating": 5,
      "bike": "Ville",
      "text": "Pour les balades tranquilles en ville, elle est parfaite pour moi. Je roule droite et je me sens mieux soutenue au niveau du bassin.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c17.png?v=1786345917",
      "reply": "Un grand merci Valérie 💙 Profitez bien de vos prochaines sorties en ville !",
      "helpfulYes": 27,
      "helpfulNo": 2,
      "model": "comfort"
    },
    {
      "name": "Florence D.",
      "rating": 5,
      "bike": "Cargo",
      "text": "Je fais beaucoup de petits trajets en cargo. Plus de confort et moins de frottements, surtout avec des vêtements normaux et pas un cuissard.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c32.png?v=1786345912",
      "reply": "Merci Florence pour votre confiance 💙 Ravies de lire que vos appuis vous semblent plus naturels.",
      "helpfulYes": 9,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Anne P.",
      "rating": 5,
      "bike": "Ville",
      "text": "Très confortable pour mon vélo de ville. J'aime le fait qu'elle reste assez ferme, je me sens mieux posée dessus.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c3.png?v=1786345910",
      "reply": "Merci Anne 💙 C'est exactement le type de retour qui nous aide à continuer d'améliorer SelloZen.",
      "helpfulYes": 16,
      "helpfulNo": 1,
      "model": "comfort"
    },
    {
      "name": "Sylvie G.",
      "rating": 5,
      "bike": "Vélo électrique urbain",
      "text": "Mon vélo électrique me sert tous les jours. Avec l'ancienne selle je me levais souvent pour soulager la pression, beaucoup moins maintenant.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c29.png?v=1786345906",
      "reply": "Merci beaucoup Sylvie 💙 Nous vous souhaitons encore de nombreuses sorties confortables !",
      "helpfulYes": 13,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Véronique V.",
      "rating": 4,
      "bike": "Ville",
      "text": "J'avais peur qu'elle soit trop large, mais avec ma position droite c'est justement ce qu'il me fallait. Très bonne surprise.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c34.png?v=1786345891",
      "reply": "Merci Véronique 💙 Nous sommes ravis que votre ville soit devenu plus agréable au quotidien. Bonne route !",
      "helpfulYes": 7,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Laure C.",
      "rating": 5,
      "bike": "Cargo",
      "text": "Sur mon cargo, je passe beaucoup de temps assise à faible vitesse. La Confort+ soutient mieux et je finis mes trajets avec moins de gêne.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c36.png?v=1786345886",
      "reply": "Merci beaucoup Laure pour ce retour détaillé 💙 Heureux que la selle vous accompagne mieux sur votre cargo.",
      "helpfulYes": 19,
      "helpfulNo": 1,
      "model": "comfort"
    },
    {
      "name": "Karine F.",
      "rating": 5,
      "bike": "Vélo électrique urbain",
      "text": "Je l'ai choisie après plusieurs selles trop étroites. Pour mon vélo électrique urbain, elle correspond beaucoup mieux à ma façon de rouler.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c27.png?v=1786345884",
      "reply": "Merci Karine 💙 Le bon réglage fait souvent une vraie différence. Très belles sorties avec votre vélo électrique urbain !",
      "helpfulYes": 24,
      "helpfulNo": 1,
      "model": "comfort"
    },
    {
      "name": "Corinne N.",
      "rating": 5,
      "bike": "Ville",
      "text": "Bonne selle pour les balades et le vélotaf tranquille. Le canal central est appréciable, surtout quand je reste longtemps assise.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c1.png?v=1786345924",
      "reply": "Merci pour votre retour Corinne 💙 Nous sommes heureux que vous ayez trouvé une position plus confortable.",
      "helpfulYes": 12,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Béatrice A.",
      "rating": 5,
      "bike": "Cargo",
      "text": "Je transporte mes enfants en cargo et je voulais vraiment privilégier le confort. Après un mois, je ne reviendrais pas à mon ancienne selle.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c11.png?v=1786345923",
      "reply": "Un grand merci Béatrice 💙 Profitez bien de vos prochaines sorties en cargo !",
      "helpfulYes": 8,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Nadia H.",
      "rating": 5,
      "bike": "Ville",
      "text": "Je roule très droite en ville. Mes appuis sont mieux répartis et je ressens moins les petits chocs sur les pavés.",
      "image": "https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c5.png?v=1786345924",
      "reply": "Merci Nadia pour votre confiance 💙 Ravies de lire que vos appuis vous semblent plus naturels.",
      "helpfulYes": 17,
      "helpfulNo": 1,
      "model": "comfort"
    },
    {
      "name": "Muriel S.",
      "rating": 5,
      "bike": "Vélo électrique urbain",
      "text": "Sur mon électrique, c'est surtout l'engourdissement qui a diminué. J'ai réglé la selle quasiment à plat et ça me va très bien.",
      "image": null,
      "reply": "Merci Muriel 💙 C'est exactement le type de retour qui nous aide à continuer d'améliorer SelloZen.",
      "helpfulYes": 10,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Virginie E.",
      "rating": 5,
      "bike": "Ville",
      "text": "Je l'utilise pour aller travailler. Très confortable avec une tenue normale, ce qui était important pour moi.",
      "image": null,
      "reply": "Merci beaucoup Virginie 💙 Nous vous souhaitons encore de nombreuses sorties confortables !",
      "helpfulYes": 21,
      "helpfulNo": 1,
      "model": "comfort"
    },
    {
      "name": "Christelle J.",
      "rating": 5,
      "bike": "Cargo",
      "text": "Montée sur un cargo longtail. La forme large est bien adaptée à ma position et je n'ai plus cette douleur aux fesses en fin de trajet.",
      "image": null,
      "reply": "Merci Christelle 💙 Nous sommes ravis que votre cargo soit devenu plus agréable au quotidien. Bonne route !",
      "helpfulYes": 6,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Delphine K.",
      "rating": 5,
      "bike": "Vélo électrique urbain",
      "text": "Je fais environ 12 km par jour en électrique. Je sens beaucoup moins la pression centrale et mon bassin est plus stable.",
      "image": null,
      "reply": "Merci beaucoup Delphine pour ce retour détaillé 💙 Heureux que la selle vous accompagne mieux sur votre vélo électrique urbain.",
      "helpfulYes": 15,
      "helpfulNo": 1,
      "model": "comfort"
    },
    {
      "name": "Fabienne O.",
      "rating": 5,
      "bike": "Ville",
      "text": "Simple, efficace. J'avais besoin d'une vraie selle de ville confortable et pas d'un modèle sportif déguisé.",
      "image": null,
      "reply": "Merci Fabienne 💙 Le bon réglage fait souvent une vraie différence. Très belles sorties avec votre ville !",
      "helpfulYes": 23,
      "helpfulNo": 1,
      "model": "comfort"
    },
    {
      "name": "Stéphanie M.",
      "rating": 4,
      "bike": "Ville",
      "text": "Après quelques jours d'adaptation, elle est devenue beaucoup plus agréable que ma selle précédente. Je roule surtout en ville et en balade.",
      "image": null,
      "reply": "Merci pour votre retour Stéphanie 💙 Nous sommes heureux que vous ayez trouvé une position plus confortable.",
      "helpfulYes": 5,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Émilie P.",
      "rating": 5,
      "bike": "Cargo",
      "text": "Très bien sur mon cargo. Même sur des trajets d'une heure, je ne cherche plus constamment à me repositionner.",
      "image": null,
      "reply": "Un grand merci Émilie 💙 Profitez bien de vos prochaines sorties en cargo !",
      "helpfulYes": 20,
      "helpfulNo": 1,
      "model": "comfort"
    },
    {
      "name": "Cécile R.",
      "rating": 5,
      "bike": "Vélo électrique urbain",
      "text": "Je voulais une selle plus adaptée à ma position très droite sur vélo électrique. C'est exactement ce que j'espérais.",
      "image": null,
      "reply": "Merci Cécile pour votre confiance 💙 Ravies de lire que vos appuis vous semblent plus naturels.",
      "helpfulYes": 9,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Monique B.",
      "rating": 5,
      "bike": "Ville",
      "text": "Je fais de petites balades le week-end. Le confort est immédiat, surtout au niveau des appuis arrière.",
      "image": null,
      "reply": "Merci Monique 💙 C'est exactement le type de retour qui nous aide à continuer d'améliorer SelloZen.",
      "helpfulYes": 12,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Gaëlle D.",
      "rating": 5,
      "bike": "Cargo",
      "text": "Sur le cargo familial, c'est beaucoup mieux. La selle est stable et je ressens moins les vibrations du mauvais revêtement.",
      "image": null,
      "reply": "Merci beaucoup Gaëlle 💙 Nous vous souhaitons encore de nombreuses sorties confortables !",
      "helpfulYes": 18,
      "helpfulNo": 1,
      "model": "comfort"
    },
    {
      "name": "Amélie G.",
      "rating": 5,
      "bike": "Ville",
      "text": "Je l'ai mise sur un vieux vélo de ville remis à neuf. C'est devenu le vélo que je prends le plus souvent maintenant.",
      "image": null,
      "reply": "Merci Amélie 💙 Nous sommes ravis que votre ville soit devenu plus agréable au quotidien. Bonne route !",
      "helpfulYes": 14,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Sonia V.",
      "rating": 5,
      "bike": "Vélo électrique urbain",
      "text": "Avec mon électrique urbain, j'avais surtout une gêne au bassin. La forme large m'aide vraiment à mieux répartir mon poids.",
      "image": null,
      "reply": "Merci beaucoup Sonia pour ce retour détaillé 💙 Heureux que la selle vous accompagne mieux sur votre vélo électrique urbain.",
      "helpfulYes": 11,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Marie L.",
      "rating": 5,
      "bike": "Ville",
      "text": "Très confortable en position droite. Je pensais qu'il fallait simplement plus de mousse, mais c'est surtout la forme qui change le ressenti.",
      "image": null,
      "reply": "Merci Marie 💙 Le bon réglage fait souvent une vraie différence. Très belles sorties avec votre ville !",
      "helpfulYes": 25,
      "helpfulNo": 1,
      "model": "comfort"
    },
    {
      "name": "Aurélie T.",
      "rating": 5,
      "bike": "Cargo",
      "text": "Parfaite pour les trajets école en cargo. Je reste assise longtemps aux feux et je suis beaucoup moins gênée qu'avant.",
      "image": null,
      "reply": "Merci pour votre retour Aurélie 💙 Nous sommes heureux que vous ayez trouvé une position plus confortable.",
      "helpfulYes": 7,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Élodie C.",
      "rating": 5,
      "bike": "Vélo électrique urbain",
      "text": "J'utilise mon VAE pour aller au travail. Après trois semaines, je confirme que les engourdissements ont fortement diminué.",
      "image": null,
      "reply": "Un grand merci Élodie 💙 Profitez bien de vos prochaines sorties en vélo électrique urbain !",
      "helpfulYes": 16,
      "helpfulNo": 1,
      "model": "comfort"
    },
    {
      "name": "Julie F.",
      "rating": 5,
      "bike": "Ville",
      "text": "Bon confort sur les pavés et les routes irrégulières. Je ressens aussi moins les points de pression sur les longues balades.",
      "image": null,
      "reply": "Merci Julie pour votre confiance 💙 Ravies de lire que vos appuis vous semblent plus naturels.",
      "helpfulYes": 10,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Caroline N.",
      "rating": 5,
      "bike": "Cargo",
      "text": "Je roule en cargo presque tous les jours. Très bonne stabilité et surtout moins besoin de bouger pour trouver une position confortable.",
      "image": null,
      "reply": "Merci Caroline 💙 C'est exactement le type de retour qui nous aide à continuer d'améliorer SelloZen.",
      "helpfulYes": 13,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Hélène A.",
      "rating": 4,
      "bike": "Ville",
      "text": "Je cherchais une selle de ville pour reprendre le vélo progressivement. Elle m'a permis de faire des sorties plus longues sans appréhension.",
      "image": null,
      "reply": "Merci beaucoup Hélène 💙 Nous vous souhaitons encore de nombreuses sorties confortables !",
      "helpfulYes": 8,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Sophie S.",
      "rating": 5,
      "bike": "Vélo électrique urbain",
      "text": "Très agréable sur vélo électrique. J'avais souvent une sensation d'écrasement à l'avant, elle est nettement moins présente maintenant.",
      "image": null,
      "reply": "Merci Sophie 💙 Nous sommes ravis que votre vélo électrique urbain soit devenu plus agréable au quotidien. Bonne route !",
      "helpfulYes": 17,
      "helpfulNo": 1,
      "model": "comfort"
    },
    {
      "name": "Claire E.",
      "rating": 5,
      "bike": "Ville",
      "text": "Je fais des trajets courts mais fréquents. La Confort+ est bien plus adaptée à ma position que la selle fine livrée avec mon vélo.",
      "image": null,
      "reply": "Merci beaucoup Claire pour ce retour détaillé 💙 Heureux que la selle vous accompagne mieux sur votre ville.",
      "helpfulYes": 6,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Agnès J.",
      "rating": 5,
      "bike": "Cargo",
      "text": "Installée sur mon cargo, rien à redire. La forme est rassurante et je garde une bonne position même avec les arrêts fréquents.",
      "image": null,
      "reply": "Merci Agnès 💙 Le bon réglage fait souvent une vraie différence. Très belles sorties avec votre cargo !",
      "helpfulYes": 15,
      "helpfulNo": 1,
      "model": "comfort"
    },
    {
      "name": "Marianne K.",
      "rating": 5,
      "bike": "Vélo électrique urbain",
      "text": "Sur mon électrique urbain, c'est devenu beaucoup plus agréable. Le soutien est meilleur et je ressens moins les vibrations dans le bassin.",
      "image": null,
      "reply": "Merci pour votre retour Marianne 💙 Nous sommes heureux que vous ayez trouvé une position plus confortable.",
      "helpfulYes": 9,
      "helpfulNo": 0,
      "model": "comfort"
    },
    {
      "name": "Audrey O.",
      "rating": 5,
      "bike": "Ville",
      "text": "Je roule surtout en ville pour les courses et les rendez-vous. Très bonne selle pour une position droite, confortable sans être molle.",
      "image": null,
      "reply": "Un grand merci Audrey 💙 Profitez bien de vos prochaines sorties en ville !",
      "helpfulYes": 12,
      "helpfulNo": 0,
      "model": "comfort"
    }
  ]
};

  const ugc = {
    sport:[
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s6.png?v=1786347341',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s8.png?v=1786347340',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s14.png?v=1786347335',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s3.png?v=1786347326',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s11.png?v=1786347325',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s13.png?v=1786347342',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s15.png?v=1786347338',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s5.png?v=1786347339',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s21.png?v=1786347337',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s20.png?v=1786347335'
    ],
    comfort:[
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c26.png?v=1786345923',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c20.png?v=1786345921',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c31.png?v=1786345918',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c28.png?v=1786345917',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c17.png?v=1786345917',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c32.png?v=1786345912',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c3.png?v=1786345910',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c29.png?v=1786345906',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c34.png?v=1786345891',
      'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c36.png?v=1786345886'
    ]
  };


  const CONFIG={
    sport:{
      name:'Sport+',
      full:'SelloZen Sport+',
      variant:SPORT_ID,
      headline:'Moins de pression sur le périnée.<br>Plus de liberté pour rouler.',
      sub:'Pour mieux dégager la zone intime en position inclinée.',
      bullets:[
        'Périnée moins comprimé',
        'Zone intime mieux dégagée',
        'Moins de frottements en position inclinée'
      ],
      geometry:'Sport+ pour une position inclinée.',
      final:'Prête à rouler avec moins de pression ?',
      packshot:'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/packshotbenefices-sport.png?v=1789480873',
      secondPackshot:'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/sellozenher-3.png?v=1789207861',
      media:[
        {
          src:'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/packshotbenefices-sport.png?v=1789480873',
          alt:'SelloZen Sport+ — bénéfices périnée et zone intime'
        },
        {
          src:'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/quellesellechoisirselonvotreposition.png?v=1789207859',
          alt:'Quelle selle choisir selon votre position'
        },
        {
          src:'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/genesfrequentes.png?v=1789207858',
          alt:'Gênes fréquentes à vélo'
        },
        {
          src:'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/sellozenher-3.png?v=1789207861',
          alt:'Packshot SelloZen Sport+'
        },
        {
          src:'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s6.png?v=1786347341',
          alt:'Avis cliente SelloZen Sport+'
        },
        {
          src:'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/s8.png?v=1786347340',
          alt:'Retour cliente SelloZen Sport+'
        }
      ]
    },
    comfort:{
      name:'Confort+',
      full:'SelloZen Confort+',
      variant:COMFORT_ID,
      headline:'Moins de pression sur le périnée.<br>Plus de liberté pour rouler.',
      sub:'Pour mieux dégager la zone intime en position droite.',
      bullets:[
        'Périnée moins comprimé',
        'Zone intime mieux dégagée',
        'Plus de confort sur la durée'
      ],
      geometry:'Confort+ pour une position droite.',
      final:'Prête à rouler avec moins de pression ?',
      packshot:'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/packshotbenefices-confort.png?v=1789480874',
      secondPackshot:'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/sellozenher-2.png?v=1789207861',
      media:[
        {
          src:'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/packshotbenefices-confort.png?v=1789480874',
          alt:'SelloZen Confort+ — bénéfices périnée et zone intime'
        },
        {
          src:'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/quellesellechoisirselonvotreposition.png?v=1789207859',
          alt:'Quelle selle choisir selon votre position'
        },
        {
          src:'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/genesfrequentes.png?v=1789207858',
          alt:'Gênes fréquentes à vélo'
        },
        {
          src:'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/sellozenher-2.png?v=1789207861',
          alt:'Packshot SelloZen Confort+'
        },
        {
          src:'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c26.png?v=1786345923',
          alt:'Avis cliente SelloZen Confort+'
        },
        {
          src:'https://cdn.shopify.com/s/files/1/1091/3677/3469/files/c20.png?v=1786345921',
          alt:'Retour cliente SelloZen Confort+'
        }
      ]
    }
  };

  function escapeHtml(value){
    return String(value||'').replace(/[&<>'\"]/g,function(character){
      return {
        '&':'&amp;',
        '<':'&lt;',
        '>':'&gt;',
        "'":'&#39;',
        '"':'&quot;'
      }[character]
    })
  }

  function renderMarquee(element,array,label){
    if(!element) return;
    const doubled=[...array,...array];
    element.innerHTML=doubled.map(function(url,index){
      return '<div class="szhf-marquee-card">'+
        '<img src="'+url+'" alt="'+label+' '+(index+1)+'" width="400" height="400" loading="lazy">'+
      '</div>'
    }).join('')
  }

  function getStickyTopOffset(){
    let offset=0;
    const selectors=[
      'header',
      '.header-wrapper',
      '.shopify-section-group-header-group',
      '[class*="announcement"]',
      '[id*="announcement"]'
    ];

    document.querySelectorAll(selectors.join(',')).forEach(function(element){
      const rect=element.getBoundingClientRect();
      const style=window.getComputedStyle(element);
      const anchored=style.position==='fixed'||style.position==='sticky';

      if(
        anchored&&
        rect.bottom>0&&
        rect.top<12&&
        rect.bottom<220
      ){
        offset=Math.max(offset,rect.bottom)
      }
    });

    return Math.max(0,Math.min(offset,170))
  }

  function scrollToRecommendationTop(){
    const target=root.querySelector('#szhfRecoHero');
    if(!target) return;

    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        const offset=getStickyTopOffset();
        const y=target.getBoundingClientRect().top+window.scrollY-offset-4;
        window.scrollTo({
          top:Math.max(0,y),
          behavior:'smooth'
        })
      })
    })
  }

  function chooseModelFromProfile(profile){
    if(profile.posture==='droite') return 'comfort';
    if(profile.posture==='inclinee') return 'sport';
    if(profile.bikeDefault==='comfort') return 'comfort';
    return 'sport'
  }

  function getPainLabel(){
    return state.pains&&state.pains.length?state.pains[0]:'Zone intime'
  }

  /* ============================================================
     GALERIE DYNAMIQUE
     ============================================================ */
  const galleryMain=root.querySelector('#szhfGalleryMain');

  function renderGallery(){
    const config=CONFIG[currentModel];
    const media=config.media;

    if(galleryIndex>=media.length){
      galleryIndex=0
    }

    const active=media[galleryIndex];

    galleryMain.innerHTML=
      '<img src="'+active.src+'" alt="'+escapeHtml(active.alt)+'" width="1254" height="1254" loading="eager">';

    const prevButton=root.querySelector('#szhfGalleryPrev');
    const nextButton=root.querySelector('#szhfGalleryNext');

    if(prevButton){
      prevButton.hidden=galleryIndex===0
    }

    if(nextButton){
      nextButton.hidden=media.length<=1
    }
  }

  root.querySelector('#szhfGalleryPrev').addEventListener('click',function(){
    const total=CONFIG[currentModel].media.length;
    galleryIndex=(galleryIndex-1+total)%total;
    renderGallery()
  });

  root.querySelector('#szhfGalleryNext').addEventListener('click',function(){
    const total=CONFIG[currentModel].media.length;
    galleryIndex=(galleryIndex+1)%total;
    renderGallery()
  });

  let galleryTouchStartX=0;
  let galleryTouchEndX=0;

  galleryMain.addEventListener('touchstart',function(event){
    galleryTouchStartX=event.changedTouches[0].clientX
  },{passive:true});

  galleryMain.addEventListener('touchend',function(event){
    galleryTouchEndX=event.changedTouches[0].clientX;
    const delta=galleryTouchEndX-galleryTouchStartX;

    if(Math.abs(delta)<44) return;

    const total=CONFIG[currentModel].media.length;

    if(delta<0){
      galleryIndex=(galleryIndex+1)%total
    }else{
      galleryIndex=(galleryIndex-1+total)%total
    }

    renderGallery()
  },{passive:true});

  /* ============================================================
     HERO / SÉLECTEUR / PROFIL
     ============================================================ */
  function updateProfileUI(){
    const postureText=state.posture==='droite'?'Position droite':state.posture==='inclinee'?'Position inclinée':'Votre posture';
    const painText=getPainLabel();

    root.querySelector('#szhfMatchBike').textContent=state.bike||'Votre vélo';
    root.querySelector('#szhfMatchPosture').textContent=postureText;
    root.querySelector('#szhfMatchPain').textContent=state.pains&&state.pains.length?painText:'Votre gêne';

    if(quizCompleted&&recommendedModel&&CONFIG[recommendedModel]){
      root.querySelector('#szhfGuideRecommendationTitle').textContent='Votre recommandation : '+CONFIG[recommendedModel].name;
      root.querySelector('#szhfGuideRecommendationMeta').textContent=[state.bike||'Votre vélo',postureText].join(' · ');
    }

    updateRecommendationDifference()
  }

  function updateRecommendationDifference(){
    const returnButton=root.querySelector('#szhfGuideReturn');
    if(!returnButton) return;

    const different=quizCompleted&&recommendedModel&&currentModel!==recommendedModel;
    returnButton.hidden=!different;

    if(different){
      returnButton.textContent='Revenir à '+CONFIG[recommendedModel].name
    }
  }

  function updateVariantSelector(){
    root.querySelectorAll('[data-model-select]').forEach(function(button){
      const selected=button.dataset.modelSelect===currentModel;
      button.classList.toggle('is-selected',selected);
      button.setAttribute('aria-checked',selected?'true':'false')
    })
  }

  root.querySelectorAll('[data-model-select]').forEach(function(button){
    button.addEventListener('click',function(){
      applyModel(button.dataset.modelSelect,false)
    })
  });

  /* ============================================================
     AVIS / UGC
     ============================================================ */
  function renderRecoSocial(){
    const list=ugc[currentModel]||[];
    renderMarquee(root.querySelector('#szhfRecoUgcTop'),list.slice(0,6),'Cliente SelloZen');
    renderMarquee(root.querySelector('#szhfRecoUgcBottom'),list.slice(4,10),'Cliente SelloZen')
  }

  function renderMiniReviews(){
    if(miniTimer){
      clearInterval(miniTimer)
    }

    const list=(REVIEWS[currentModel]||[]).slice(0,5);
    const track=root.querySelector('#szhfMiniTrack');
    const dots=root.querySelector('#szhfMiniDots');
    let currentIndex=0;

    track.innerHTML=list.map(function(review){
      const preview=review.text.length>125?review.text.slice(0,122)+'…':review.text;

      return '<div class="szhf-mini-card">'+
        '<div class="stars">'+('★'.repeat(review.rating))+'</div>'+
        '<blockquote>“'+escapeHtml(preview)+'”</blockquote>'+
        '<small>'+escapeHtml(review.name)+' · '+escapeHtml(review.bike)+'</small>'+
      '</div>'
    }).join('');

    dots.innerHTML=list.map(function(_,index){
      return '<button type="button" aria-label="Avis '+(index+1)+'" class="'+(index===0?'is-active':'')+'"></button>'
    }).join('');

    function goTo(index){
      currentIndex=(index+list.length)%list.length;
      track.style.transform='translateX(-'+(currentIndex*100)+'%)';
      [...dots.children].forEach(function(dot,dotIndex){
        dot.classList.toggle('is-active',dotIndex===currentIndex)
      })
    }

    [...dots.children].forEach(function(dot,index){
      dot.addEventListener('click',function(){
        goTo(index)
      })
    });

    miniTimer=setInterval(function(){
      goTo(currentIndex+1)
    },5200)
  }

  function renderReviews(){
    const list=REVIEWS[currentModel]||[];
    const host=root.querySelector('#szhfReviewList');

    host.innerHTML=list.slice(0,reviewVisible).map(function(review,index){
      const avatar=review.image
        ?'<div class="szhf-review-avatar"><img src="'+review.image+'" alt="Avis '+escapeHtml(review.name)+'" width="180" height="180" loading="lazy"></div>'
        :'<div class="szhf-review-avatar"></div>';

      const image=review.image&&index<5
        ?'<div class="szhf-review-image"><img src="'+review.image+'" alt="Photo avis '+escapeHtml(review.name)+'" width="700" height="700" loading="lazy"></div>'
        :'';

      return '<article class="szhf-review-card">'+
        '<div class="szhf-review-top">'+
          '<div class="szhf-review-person">'+
            avatar+
            '<div>'+
              '<div class="szhf-review-name">'+escapeHtml(review.name)+'</div>'+
              '<div class="szhf-review-bike">'+escapeHtml(review.bike)+'</div>'+
            '</div>'+
          '</div>'+
          '<div class="szhf-review-stars">'+('★'.repeat(review.rating))+('☆'.repeat(5-review.rating))+'</div>'+
        '</div>'+
        '<div class="szhf-review-text">'+escapeHtml(review.text)+'</div>'+
        image+
        '<div class="szhf-review-reply"><strong>Réponse SelloZen</strong><br>'+escapeHtml(review.reply)+'</div>'+
        '<div class="szhf-review-help">'+
          '<span>Utile ?</span>'+
          '<button type="button">👍 '+review.helpfulYes+'</button>'+
          '<button type="button">👎 '+review.helpfulNo+'</button>'+
        '</div>'+
      '</article>'
    }).join('');

    const moreButton=root.querySelector('#szhfLoadMore');
    moreButton.style.display=reviewVisible>=list.length?'none':'block'
  }

  root.querySelector('#szhfLoadMore').addEventListener('click',function(){
    reviewVisible+=6;
    renderReviews()
  });

  /* ============================================================
     IMAGE FINALE + PANIER
     ============================================================ */
  function updateFinalImage(){
    const config=CONFIG[currentModel];
    root.querySelector('#szhfFinalDynamicImage').innerHTML=
      '<img src="'+config.secondPackshot+'" alt="'+escapeHtml(config.full)+'" width="1254" height="1254" loading="lazy">'
  }

  function setCartThumb(){
    const config=CONFIG[currentModel];
    root.querySelector('#szhfCartThumb').innerHTML=
      '<img src="'+config.packshot+'" alt="'+escapeHtml(config.full)+'" width="180" height="180">'
  }

  /* ============================================================
     APPLICATION DU MODÈLE
     ============================================================ */
  function applyModel(model,fromQuiz){
    if(!CONFIG[model]){
      model='sport'
    }

    currentModel=model;
    state.model=model;
    variantId=CONFIG[model].variant;
    galleryIndex=0;
    reviewVisible=6;

    const config=CONFIG[model];

    root.dataset.model=model;

    root.querySelector('#szhfModelLabel').textContent=config.full;
    root.querySelector('#szhfRecoHeadline').innerHTML=config.headline;
    root.querySelector('#szhfRecoSub').textContent=config.sub;
    root.querySelector('#szhfGeometryCopy').textContent=config.geometry;
    root.querySelector('#szhfFinalHeadline').textContent=config.final;
    root.querySelector('#szhfStickyModel').textContent=config.name;
    root.querySelector('#szhfCartProductName').textContent=config.full;

    if(typeof updateCartProductControls==='function'){
      updateCartProductControls()
    }

    root.querySelector('#szhfRecoBullets').innerHTML=config.bullets.map(function(text){
      return '<div><span class="szhf-round-check"></span><strong>'+escapeHtml(text)+'</strong></div>'
    }).join('');

    updateVariantSelector();
    updateProfileUI();
    renderGallery();
    renderRecoSocial();
    renderMiniReviews();
    renderReviews();
    updateFinalImage();
    setCartThumb();

    localStorage.setItem('sellozenHerModel',model);

    if(quizCompleted){
      localStorage.setItem('sellozenHerBike',state.bike||'');
      localStorage.setItem('sellozenHerPosture',state.posture||'');
      localStorage.setItem('sellozenHerPain',(state.pains||[]).join(', '));
    }

    if(fromQuiz){
      const guide=root.querySelector('#szhfGuideWidget');
      if(guide){
        setTimeout(function(){
          const offset=getStickyTopOffset();
          const y=guide.getBoundingClientRect().top+window.scrollY-offset-8;
          window.scrollTo({top:Math.max(0,y),behavior:'smooth'})
        },80)
      }
    }
  }

  /* ============================================================
     GUIDE / QUIZ INLINE
     ============================================================ */
  const guideWidget=root.querySelector('#szhfGuideWidget');
  const guideCollapsed=root.querySelector('#szhfGuideCollapsed');
  const guideFlow=root.querySelector('#szhfGuideFlow');
  const guideResultCard=root.querySelector('#szhfGuideResultCard');
  const guideSteps=[...root.querySelectorAll('[data-guide-step]')];
  const guideProgress=[...root.querySelectorAll('#szhfGuideProgress i')];
  const guideResultButton=root.querySelector('#szhfGuideResultButton');
  const guideAnalysis=root.querySelector('#szhfGuideAnalysis');
  const guideAnalysisRows=[...root.querySelectorAll('[data-guide-analysis]')];
  const guideAnalysisBar=root.querySelector('#szhfGuideAnalysisBar');
  const guideAnalysisPercent=root.querySelector('#szhfGuideAnalysisPercent');

  const guideState={
    bike:null,
    bikeDefault:null,
    posture:null,
    pains:[]
  };

  function showGuideStep(step){
    guideSteps.forEach(function(element){
      element.classList.toggle('is-active',Number(element.dataset.guideStep)===step)
    });

    guideProgress.forEach(function(bar,index){
      bar.classList.toggle('is-active',index<step)
    });

    guideAnalysis.hidden=true;

    requestAnimationFrame(function(){
      const offset=getStickyTopOffset();
      const y=guideWidget.getBoundingClientRect().top+window.scrollY-offset-8;
      window.scrollTo({top:Math.max(0,y),behavior:'smooth'})
    })
  }

  function resetGuide(){
    guideState.bike=null;
    guideState.bikeDefault=null;
    guideState.posture=null;
    guideState.pains=[];

    root.querySelectorAll('.szhf-guide-choice').forEach(function(choice){
      choice.classList.remove('is-selected')
    });

    guideResultButton.disabled=true;
    guideAnalysis.hidden=true;
    guideAnalysisRows.forEach(function(row){
      row.classList.remove('is-active','is-done')
    });
    guideAnalysisBar.style.width='0%';
    guideAnalysisPercent.textContent='0 %';
    showGuideStep(1)
  }

  function openGuide(){
    resetGuide();
    guideCollapsed.hidden=true;
    guideResultCard.hidden=true;
    guideFlow.hidden=false;
    showGuideStep(1)
  }

  function closeGuide(){
    guideFlow.hidden=true;
    if(quizCompleted){
      guideResultCard.hidden=false;
      guideCollapsed.hidden=true
    }else{
      guideResultCard.hidden=true;
      guideCollapsed.hidden=false
    }
  }

  function renderGuideState(){
    if(quizCompleted&&recommendedModel&&CONFIG[recommendedModel]){
      guideCollapsed.hidden=true;
      guideFlow.hidden=true;
      guideResultCard.hidden=false
    }else{
      guideCollapsed.hidden=false;
      guideFlow.hidden=true;
      guideResultCard.hidden=true
    }

    updateProfileUI()
  }

  root.querySelector('#szhfGuideStart').addEventListener('click',openGuide);
  root.querySelector('#szhfGuideClose').addEventListener('click',closeGuide);
  root.querySelector('#szhfGuideModify').addEventListener('click',openGuide);
  root.querySelector('#szhfGuideReturn').addEventListener('click',function(){
    if(recommendedModel){
      applyModel(recommendedModel,false)
    }
  });

  root.querySelectorAll('[data-guide-back]').forEach(function(button){
    button.addEventListener('click',function(){
      showGuideStep(Number(button.dataset.guideBack))
    })
  });

  root.querySelectorAll('[data-guide-bike]').forEach(function(button){
    button.addEventListener('click',function(){
      root.querySelectorAll('[data-guide-bike]').forEach(function(other){
        other.classList.remove('is-selected')
      });

      button.classList.add('is-selected');
      guideState.bike=button.dataset.guideBike;
      guideState.bikeDefault=button.dataset.guideDefault;

      setTimeout(function(){
        showGuideStep(2)
      },130)
    })
  });

  root.querySelectorAll('[data-guide-posture]').forEach(function(button){
    button.addEventListener('click',function(){
      root.querySelectorAll('[data-guide-posture]').forEach(function(other){
        other.classList.remove('is-selected')
      });

      button.classList.add('is-selected');
      guideState.posture=button.dataset.guidePosture;

      setTimeout(function(){
        showGuideStep(3)
      },130)
    })
  });

  root.querySelectorAll('[data-guide-pain]').forEach(function(button){
    button.addEventListener('click',function(){
      button.classList.toggle('is-selected');
      const pain=button.dataset.guidePain;

      if(button.classList.contains('is-selected')){
        guideState.pains=[...new Set([...guideState.pains,pain])]
      }else{
        guideState.pains=guideState.pains.filter(function(item){
          return item!==pain
        })
      }

      guideResultButton.disabled=guideState.pains.length===0
    })
  });

  function runGuideAnalysis(){
    guideSteps.forEach(function(step){
      step.classList.remove('is-active')
    });

    guideAnalysis.hidden=false;
    guideAnalysisRows.forEach(function(row){
      row.classList.remove('is-active','is-done')
    });

    const timings=[0,700,1400,2100];
    const percentages=[22,48,74,96];

    timings.forEach(function(delay,index){
      setTimeout(function(){
        guideAnalysisRows.forEach(function(row,rowIndex){
          if(rowIndex<index){
            row.classList.add('is-done');
            row.classList.remove('is-active')
          }
        });

        guideAnalysisRows[index].classList.add('is-active');
        guideAnalysisBar.style.width=percentages[index]+'%';
        guideAnalysisPercent.textContent=percentages[index]+' %'
      },delay)
    });

    setTimeout(function(){
      guideAnalysisRows.forEach(function(row){
        row.classList.add('is-done');
        row.classList.remove('is-active')
      });
      guideAnalysisBar.style.width='100%';
      guideAnalysisPercent.textContent='100 %'
    },2800);

    setTimeout(function(){
      state.bike=guideState.bike;
      state.bikeDefault=guideState.bikeDefault;
      state.posture=guideState.posture;
      state.pains=[...guideState.pains];

      recommendedModel=chooseModelFromProfile(guideState);
      quizCompleted=true;

      localStorage.setItem('sellozenHerQuizCompleted','true');
      localStorage.setItem('sellozenHerRecommendedModel',recommendedModel);
      localStorage.setItem('sellozenHerBike',state.bike||'');
      localStorage.setItem('sellozenHerPosture',state.posture||'');
      localStorage.setItem('sellozenHerPain',(state.pains||[]).join(', '));

      guideFlow.hidden=true;
      guideResultCard.hidden=false;
      guideCollapsed.hidden=true;

      applyModel(recommendedModel,true);
      renderGuideState()
    },3250)
  }

  guideResultButton.addEventListener('click',function(){
    if(
      !guideState.bike||
      !guideState.posture||
      !guideState.pains.length
    ){
      return
    }

    runGuideAnalysis()
  });

  /* ============================================================
     STICKY ATC
     ============================================================ */
  const sticky=root.querySelector('#szhfSticky');
  const hero=root.querySelector('#szhfRecoHero');
  const final=root.querySelector('#szhfFinal');

  function updateSticky(){
    const shouldShow=!heroVisible&&!finalVisible;
    sticky.classList.toggle('is-visible',shouldShow);
    sticky.setAttribute('aria-hidden',shouldShow?'false':'true')
  }

  const heroObserver=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      heroVisible=entry.isIntersecting;
      updateSticky()
    })
  },{
    threshold:.15
  });

  const finalObserver=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      finalVisible=entry.isIntersecting;
      updateSticky()
    })
  },{
    threshold:.15
  });

  if(hero){
    heroObserver.observe(hero)
  }

  if(final){
    finalObserver.observe(final)
  }

  /* ============================================================
     PANIER — SYNCHRONISÉ AVEC LE DRAWER SHOPIFY OFFICIEL
     ============================================================ */
  const cartBg=root.querySelector('#szhfCartBg');
  const cartSwitch=root.querySelector('#szhfCartSwitch');
  const cartRemove=root.querySelector('#szhfCartRemove');
  const cartStatus=root.querySelector('#szhfCartProductStatus');
  const cartQuantity=root.querySelector('#szhfCartQuantity');
  const cartTotalCompare=root.querySelector('#szhfCartTotalCompare');
  const cartTotalCurrent=root.querySelector('#szhfCartTotalCurrent');

  let cartBusy=false;
  let popupVariantId=null;

  function shopRoot(){
    return window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root
      ?window.Shopify.routes.root
      :'/';
  }

  function formatMoney(cents){
    return (Number(cents||0)/100).toLocaleString('fr-FR',{
      minimumFractionDigits:2,
      maximumFractionDigits:2
    })+' €';
  }

  async function fetchCartState(){
    const official=window.SelloZenOfficialCart;
    if(official&&typeof official.fetchCart==='function'){
      return official.fetchCart();
    }

    const response=await fetch(shopRoot()+'cart.js',{
      headers:{'Accept':'application/json'},
      cache:'no-store'
    });

    if(!response.ok){
      throw new Error('Impossible de lire le panier.');
    }

    return response.json();
  }

  function getDrawerSections(){
    const drawer=document.querySelector('cart-drawer');
    if(!drawer||typeof drawer.getSectionsToRender!=='function'){
      return [];
    }

    return drawer.getSectionsToRender().map(function(section){
      return section.id;
    }).filter(Boolean);
  }

  function renderOfficialDrawerSilently(data){
    const official=window.SelloZenOfficialCart;
    if(official&&typeof official.render==='function'){
      official.render(data,{open:false});
      return;
    }

    const drawer=document.querySelector('cart-drawer');
    if(!drawer||!data||!data.sections||typeof drawer.renderContents!=='function'){
      return;
    }

    const originalOpen=typeof drawer.open==='function'?drawer.open:null;
    const wasActive=drawer.classList.contains('active');

    if(originalOpen){
      drawer.open=function(){};
    }

    drawer.renderContents(data);

    window.setTimeout(function(){
      if(originalOpen){
        drawer.open=originalOpen;
      }
      if(!wasActive){
        drawer.classList.remove('active');
      }
    },220);
  }

  async function fallbackUpdateLines(updates){
    const sections=getDrawerSections();
    const body={updates:updates};

    if(sections.length){
      body.sections=sections;
      body.sections_url=window.location.pathname;
    }

    const response=await fetch(shopRoot()+'cart/update.js',{
      method:'POST',
      headers:{
        'Content-Type':'application/json',
        'Accept':'application/json',
        'X-Requested-With':'XMLHttpRequest'
      },
      body:JSON.stringify(body)
    });

    const data=await response.json();

    if(!response.ok){
      throw new Error(data.description||data.message||'Impossible de mettre à jour le panier.');
    }

    renderOfficialDrawerSilently(data);
    return data;
  }

  async function fallbackAddVariant(variant,quantity){
    const sections=getDrawerSections();
    const form=new FormData();
    form.append('id',String(variant));
    form.append('quantity',String(quantity));

    if(sections.length){
      form.append('sections',sections.join(','));
      form.append('sections_url',window.location.pathname);
    }

    const response=await fetch(shopRoot()+'cart/add.js',{
      method:'POST',
      headers:{'X-Requested-With':'XMLHttpRequest'},
      body:form
    });

    const data=await response.json();

    if(!response.ok){
      throw new Error(data.description||data.message||'Impossible d’ajouter la selle.');
    }

    renderOfficialDrawerSilently(data);
    return data;
  }

  async function addOrIncrementVariant(variant){
    const official=window.SelloZenOfficialCart;
    if(official&&typeof official.addOrIncrementVariant==='function'){
      const result=await official.addOrIncrementVariant(variant,1,{open:false});
      return result.cart;
    }

    const cart=await fetchCartState();
    const matches=cart.items.filter(function(item){
      return Number(item.variant_id)===Number(variant);
    });

    if(matches.length){
      const total=matches.reduce(function(sum,item){
        return sum+Number(item.quantity||0);
      },0);
      const updates={};
      updates[matches[0].key]=total+1;
      matches.slice(1).forEach(function(item){updates[item.key]=0});
      await fallbackUpdateLines(updates);
    }else{
      await fallbackAddVariant(variant,1);
    }

    return fetchCartState();
  }

  async function removeVariantFromCart(variant){
    const official=window.SelloZenOfficialCart;
    if(official&&typeof official.removeVariant==='function'){
      const result=await official.removeVariant(variant,{open:false});
      return result.cart;
    }

    const cart=await fetchCartState();
    const matches=cart.items.filter(function(item){
      return Number(item.variant_id)===Number(variant);
    });

    if(!matches.length){
      return cart;
    }

    const updates={};
    matches.forEach(function(item){updates[item.key]=0});
    await fallbackUpdateLines(updates);
    return fetchCartState();
  }

  async function replaceCartVariant(fromVariant,toVariant){
    const official=window.SelloZenOfficialCart;
    if(official&&typeof official.replaceVariant==='function'){
      const result=await official.replaceVariant(fromVariant,toVariant,{open:false});
      return result.cart;
    }

    const cart=await fetchCartState();
    const fromMatches=cart.items.filter(function(item){
      return Number(item.variant_id)===Number(fromVariant);
    });
    const qty=fromMatches.reduce(function(sum,item){
      return sum+Number(item.quantity||0);
    },0);

    if(!qty){
      return addOrIncrementVariant(toVariant);
    }

    /* Ajout de la nouvelle variante, puis suppression de l'ancienne. */
    await fallbackAddVariant(toVariant,qty);
    const afterAdd=await fetchCartState();
    const oldLines=afterAdd.items.filter(function(item){
      return Number(item.variant_id)===Number(fromVariant);
    });
    const updates={};
    oldLines.forEach(function(item){updates[item.key]=0});
    await fallbackUpdateLines(updates);
    return fetchCartState();
  }

  function setCartBusy(isBusy){
    cartBusy=isBusy;
    cartSwitch.disabled=isBusy;
    cartRemove.disabled=isBusy;
    root.querySelectorAll('[data-atc]').forEach(function(button){
      button.disabled=isBusy;
    });
  }

  function updateCartProductControls(){
    const otherModel=currentModel==='sport'?'comfort':'sport';
    const otherConfig=CONFIG[otherModel];
    cartSwitch.textContent='Changer pour '+otherConfig.name;

    if(quizCompleted&&recommendedModel===currentModel){
      cartStatus.textContent='Recommandée selon votre profil';
    }else{
      cartStatus.textContent='Modèle sélectionné';
    }
  }

  function getVariantQuantity(cart,variant){
    return cart.items.filter(function(item){
      return Number(item.variant_id)===Number(variant);
    }).reduce(function(sum,item){
      return sum+Number(item.quantity||0);
    },0);
  }

  function getVariantLineTotal(cart,variant){
    return cart.items.filter(function(item){
      return Number(item.variant_id)===Number(variant);
    }).reduce(function(sum,item){
      return sum+Number(item.final_line_price||0);
    },0);
  }

  function updatePopupFromCart(cart,variant){
    const qty=getVariantQuantity(cart,variant);
    const lineTotal=getVariantLineTotal(cart,variant);
    const compareTotal=8990*qty;

    cartQuantity.textContent='Quantité : '+Math.max(qty,1);
    cartTotalCurrent.textContent=formatMoney(lineTotal||5990);
    cartTotalCompare.textContent=formatMoney(compareTotal||8990);
  }

  async function syncCartUi(){
    try{
      const cart=await fetchCartState();
        return cart;
    }catch(error){
      console.error('SelloZen cart sync:',error);
      return null;
    }
  }

  function openCart(){
    cartBg.hidden=false;
    document.documentElement.style.overflow='hidden';
    document.body.style.overflow='hidden';
  }

  function closeCart(){
    cartBg.hidden=true;
    document.documentElement.style.overflow='';
    document.body.style.overflow='';
  }

  async function addToCart(){
    if(cartBusy){
      return;
    }

    try{
      setCartBusy(true);
      popupVariantId=variantId;
      const cart=await addOrIncrementVariant(popupVariantId);
      updateCartProductControls();
      updatePopupFromCart(cart,popupVariantId);
      openCart();
    }catch(error){
      console.error('SelloZen add:',error);
      alert('Impossible d’ajouter au panier pour le moment.');
    }finally{
      setCartBusy(false);
    }
  }

  root.querySelectorAll('[data-atc]').forEach(function(button){
    button.addEventListener('click',addToCart);
  });

  cartSwitch.addEventListener('click',async function(){
    if(cartBusy){
      return;
    }

    const previousVariant=popupVariantId||variantId;
    const nextModel=currentModel==='sport'?'comfort':'sport';
    const nextVariant=CONFIG[nextModel].variant;

    try{
      setCartBusy(true);
      const cart=await replaceCartVariant(previousVariant,nextVariant);
      applyModel(nextModel,false);
      popupVariantId=nextVariant;
      updateCartProductControls();
      updatePopupFromCart(cart,popupVariantId);
    }catch(error){
      console.error('SelloZen switch:',error);
      alert('Impossible de changer de modèle pour le moment.');
    }finally{
      setCartBusy(false);
    }
  });

  cartRemove.addEventListener('click',async function(){
    if(cartBusy){
      return;
    }

    try{
      setCartBusy(true);
      const targetVariant=popupVariantId||variantId;
      const cart=await removeVariantFromCart(targetVariant);
        popupVariantId=null;
      closeCart();
    }catch(error){
      console.error('SelloZen remove:',error);
      alert('Impossible de supprimer cet article pour le moment.');
    }finally{
      setCartBusy(false);
    }
  });


  root.querySelector('#szhfCartClose').addEventListener('click',closeCart);
  root.querySelector('#szhfContinue').addEventListener('click',closeCart);

  cartBg.addEventListener('click',function(event){
    if(event.target===cartBg){
      closeCart();
    }
  });

  root.querySelector('#szhfCheckout').addEventListener('click',function(){
    window.location.href=shopRoot()+'checkout';
  });

  /* Synchronise silencieusement le panier Shopify dès l’arrivée sur la page. */
  syncCartUi();

  /* ============================================================
     INITIALISATION
     ============================================================ */
  /* Toujours commencer sur Confort+ au chargement. */
  state.model='comfort';
  currentModel='comfort';
  variantId=COMFORT_ID;

  applyModel('comfort',false);
  renderGuideState()
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
